import './QuizQuestion.css';

function MultipleChoiceQuestion({ question, selectedAnswer, onAnswerSelect }) {
    return (
        <div className="multiple-choice-question">
            <h2 className="question-text">{question.questionText}</h2>

            <div className="choices-container">
                {question.choices.map((choice) => (
                    <div
                        key={choice.id}
                        className={`choice-item ${selectedAnswer === choice.id ? 'selected' : ''}`}
                        onClick={() => onAnswerSelect(choice.id)}
                    >
                        <div className="choice-radio">
                            <div className="radio-outer">
                                {selectedAnswer === choice.id && (
                                    <div className="radio-inner"></div>
                                )}
                            </div>
                        </div>
                        <div className="choice-text">{choice.text}</div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default MultipleChoiceQuestion;
